/* eslint-disable id-blacklist */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as Types from './operations';

const defaultOptions = {} as const;
export const CommonTournamentFragmentDoc = gql`
  fragment CommonTournament on TournamentData {
    id: tournamentId
    bounty
    entrants
    legacyStatus
    prizePool
    prizePoolValue
    prizePoolUnit
    initStack
    avgStack
    timeClosed
    paidPlaces
    winner
    winnerAward
    siteVisibilityMask
    favReference
    internalReference
    currentLevel {
      blindsLevel
      handType
      structure
      hilo
      stakes {
        antes
        blinds
        stakes
        bringIns
      }
    }
  }
`;
export const SidecarDataFragmentDoc = gql`
  fragment SidecarData on TournamentData {
    isRestricted
    isFlightTourn
    awardSchema
    tournFlags2
    satelliteTarget
    satelliteTargetNameMTT
    reEntryAllowed
    timedTournType
    timedTournPlayersPercent
    tournFlagsServInt
    tournGroup: tournGroup_
    initStack
    avgStack
    timeClosed
    paidPlaces
    winner
    winnerAward
    currentLevel {
      blindsLevel
      handType
      structure
      hilo
      stakes {
        antes
        blinds
        stakes
        bringIns
      }
    }
  }
`;
export const TournamentsQueryFragmentDoc = gql`
  fragment TournamentsQuery on TournamentData {
    ...CommonTournament
    ...SidecarData
    whenStartInt: whenStart_t
    regEndInt: regEnd_t
    regStartInt: regStart_t
    tournFlags
    fee
    buyIn
    name
    tournTypeName
    mobileName: mobileName_
    pokerNgGroup
    currency
    seats
    channels
    tournSpeed
    tournSpeedInt
    whenStart
    maxPlayers
    minPlayers
    game
    gameInt
    structure
    structureInt
    isHiLo
    bounty
  }
  ${CommonTournamentFragmentDoc}
  ${SidecarDataFragmentDoc}
`;
export const TournamentsDocument = gql`
  query Tournaments($include: Filter, $exclude: Filter) {
    tournaments(include: $include, exclude: $exclude) {
      ...TournamentsQuery
    }
  }
  ${TournamentsQueryFragmentDoc}
`;

/**
 * __useTournamentsQuery__
 *
 * To run a query within a React component, call `useTournamentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentsQuery({
 *   variables: {
 *      include: // value for 'include'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useTournamentsQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.TournamentsQuery, Types.TournamentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.TournamentsQuery, Types.TournamentsQueryVariables>(
    TournamentsDocument,
    options
  );
}
export function useTournamentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.TournamentsQuery, Types.TournamentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.TournamentsQuery, Types.TournamentsQueryVariables>(
    TournamentsDocument,
    options
  );
}
export function useTournamentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.TournamentsQuery, Types.TournamentsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.TournamentsQuery, Types.TournamentsQueryVariables>(
    TournamentsDocument,
    options
  );
}
export type TournamentsQueryHookResult = ReturnType<typeof useTournamentsQuery>;
export type TournamentsLazyQueryHookResult = ReturnType<typeof useTournamentsLazyQuery>;
export type TournamentsSuspenseQueryHookResult = ReturnType<typeof useTournamentsSuspenseQuery>;
export type TournamentsQueryResult = Apollo.QueryResult<
  Types.TournamentsQuery,
  Types.TournamentsQueryVariables
>;
export const OnTournamentsUpdateDocument = gql`
  subscription OnTournamentsUpdate($include: Filter, $exclude: Filter) {
    crud(include: $include, exclude: $exclude) {
      __typename
      ... on Initial {
        ...TournamentsQuery
      }
      ... on Create {
        ...TournamentsQuery
      }
      ... on Update {
        ...CommonTournament
      }
      ... on Delete {
        id: tournamentId
      }
    }
  }
  ${TournamentsQueryFragmentDoc}
  ${CommonTournamentFragmentDoc}
`;

/**
 * __useOnTournamentsUpdateSubscription__
 *
 * To run a query within a React component, call `useOnTournamentsUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTournamentsUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTournamentsUpdateSubscription({
 *   variables: {
 *      include: // value for 'include'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useOnTournamentsUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    Types.OnTournamentsUpdateSubscription,
    Types.OnTournamentsUpdateSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.OnTournamentsUpdateSubscription,
    Types.OnTournamentsUpdateSubscriptionVariables
  >(OnTournamentsUpdateDocument, options);
}
export type OnTournamentsUpdateSubscriptionHookResult = ReturnType<
  typeof useOnTournamentsUpdateSubscription
>;
export type OnTournamentsUpdateSubscriptionResult =
  Apollo.SubscriptionResult<Types.OnTournamentsUpdateSubscription>;
export const TournamentsMockDocument = gql`
  query TournamentsMock($include: Filter, $exclude: Filter) {
    mock(include: $include, exclude: $exclude) {
      ...TournamentsQuery
    }
  }
  ${TournamentsQueryFragmentDoc}
`;

/**
 * __useTournamentsMockQuery__
 *
 * To run a query within a React component, call `useTournamentsMockQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentsMockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentsMockQuery({
 *   variables: {
 *      include: // value for 'include'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useTournamentsMockQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.TournamentsMockQuery,
    Types.TournamentsMockQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.TournamentsMockQuery, Types.TournamentsMockQueryVariables>(
    TournamentsMockDocument,
    options
  );
}
export function useTournamentsMockLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TournamentsMockQuery,
    Types.TournamentsMockQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.TournamentsMockQuery, Types.TournamentsMockQueryVariables>(
    TournamentsMockDocument,
    options
  );
}
export function useTournamentsMockSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.TournamentsMockQuery,
        Types.TournamentsMockQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.TournamentsMockQuery, Types.TournamentsMockQueryVariables>(
    TournamentsMockDocument,
    options
  );
}
export type TournamentsMockQueryHookResult = ReturnType<typeof useTournamentsMockQuery>;
export type TournamentsMockLazyQueryHookResult = ReturnType<typeof useTournamentsMockLazyQuery>;
export type TournamentsMockSuspenseQueryHookResult = ReturnType<
  typeof useTournamentsMockSuspenseQuery
>;
export type TournamentsMockQueryResult = Apollo.QueryResult<
  Types.TournamentsMockQuery,
  Types.TournamentsMockQueryVariables
>;
export const OnTournamentsUpdateMockDocument = gql`
  subscription OnTournamentsUpdateMock($include: Filter, $exclude: Filter) {
    crudm(include: $include, exclude: $exclude) {
      __typename
      ... on Initial {
        ...TournamentsQuery
      }
      ... on Create {
        ...TournamentsQuery
      }
      ... on Update {
        ...CommonTournament
      }
      ... on Delete {
        id: tournamentId
      }
    }
  }
  ${TournamentsQueryFragmentDoc}
  ${CommonTournamentFragmentDoc}
`;

/**
 * __useOnTournamentsUpdateMockSubscription__
 *
 * To run a query within a React component, call `useOnTournamentsUpdateMockSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTournamentsUpdateMockSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTournamentsUpdateMockSubscription({
 *   variables: {
 *      include: // value for 'include'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useOnTournamentsUpdateMockSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    Types.OnTournamentsUpdateMockSubscription,
    Types.OnTournamentsUpdateMockSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.OnTournamentsUpdateMockSubscription,
    Types.OnTournamentsUpdateMockSubscriptionVariables
  >(OnTournamentsUpdateMockDocument, options);
}
export type OnTournamentsUpdateMockSubscriptionHookResult = ReturnType<
  typeof useOnTournamentsUpdateMockSubscription
>;
export type OnTournamentsUpdateMockSubscriptionResult =
  Apollo.SubscriptionResult<Types.OnTournamentsUpdateMockSubscription>;
